// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__Qr4dT","productName":"Table_productName__2aEWQ"};